function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS CheckBoxField INSTEAD.
import React, { PureComponent } from 'react';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { fieldProps, getPreferredProp } from "../utils";
import FormInputContainer from "../../internal/FormInputContainer";
var CheckBoxField = /*#__PURE__*/function (_PureComponent) {
  function CheckBoxField(props) {
    var _this;
    _classCallCheck(this, CheckBoxField);
    _this = _callSuper(this, CheckBoxField, [props]);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }
  _inherits(CheckBoxField, _PureComponent);
  return _createClass(CheckBoxField, [{
    key: "onChange",
    value: function onChange(e) {
      var value = e.target.checked;
      var callback = getPreferredProp(this.props, 'onChange');
      if (isFunction(callback)) {
        callback(e);
      }
      if (isFunction(this.props.onChange) && this.props.onChange !== callback) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        hideLabel = _this$props.hideLabel,
        hint = _this$props.hint,
        id = _this$props.id,
        label = _this$props.label,
        labelPosition = _this$props.labelPosition,
        showError = _this$props.showError,
        showHint = _this$props.showHint;
      var hasError = getPreferredProp(this.props, 'invalid') && getPreferredProp(this.props, 'touched');
      var containerClass = function containerClass() {
        return classNames({
          'ui-checkbox-field': true,
          'ui-form-field': true,
          'ui-form-field--inline': inline,
          'ui-form-field--disabled': disabled,
          'ui-checkbox-field--has-error': hasError,
          'ui-form-field--has-error': hasError
        }, className);
      };
      var labelClass = function labelClass() {
        return classNames({
          'ui-form-field__label': true,
          'ui-form-field__label--left': labelPosition === 'left',
          'sr-only': hideLabel
        });
      };
      return /*#__PURE__*/React.createElement(FormInputContainer, {
        className: containerClass(),
        styles: style,
        hint: hint,
        error: getPreferredProp(this.props, 'error'),
        showError: showError,
        showHint: showHint
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        id: id,
        type: "checkbox",
        checked: getPreferredProp(this.props, 'value') || getPreferredProp(this.props, 'checked'),
        onChange: this.onChange,
        onBlur: getPreferredProp(this.props, 'onBlur'),
        onFocus: getPreferredProp(this.props, 'onFocus'),
        name: getPreferredProp(this.props, 'name'),
        disabled: disabled
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: id,
        className: labelClass()
      }, label)));
    }
  }]);
}(PureComponent);
/**
 * disable no-unused-prop-types handled by utility functions
*/
CheckBoxField.propTypes = _objectSpread({
  /** id for reference */
  id: PropTypes.string.isRequired,
  /** is the Toggle checked or not */
  checked: PropTypes.bool,
  // eslint-disable-line react/no-unused-prop-types
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the elements || **Not Recommended** */
  style: PropTypes.shape({
    container: PropTypes.object,
    label: PropTypes.object,
    input: PropTypes.object,
    hint: PropTypes.object
  }),
  /** Should the label be hidden? */
  hideLabel: PropTypes.bool,
  /** label text for button */
  label: PropTypes.string.isRequired,
  /** Position of the label */
  labelPosition: PropTypes.oneOf(['right', 'left']),
  /** Is the input disabled? */
  disabled: PropTypes.bool,
  /** Help text displayed below the input */
  hint: PropTypes.node,
  /** Show Error HTML defaults to true */
  showError: PropTypes.bool,
  /** Show Hint HTML defaults to true */
  showHint: PropTypes.bool
}, fieldProps);
CheckBoxField.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  hideLabel: false,
  hint: '',
  labelPosition: 'right',
  showError: true,
  showHint: true,
  style: {
    container: {},
    label: {},
    input: {},
    hint: {},
    error: {}
  }
};
export default CheckBoxField;